<oaibox-stats-card title="Update Domain" icon="fa-solid fa-shield-halved" gradient="primary">
  <form class="form p-g" [formGroup]="updateDeploymentDomainForm">
    <div>
      <label for="domain" class="form-label">Domain</label>
      <input id="domain" type="text" class="form-control" [formControl]="updateDeploymentDomainForm.controls.domain">

      <div class="info">
        <i class="fa-solid fa-circle-info"></i>
        Changing this email domain will update who has access to this deployment.
      </div>
    </div>

    <footer>
      <button type="button" class="btn btn-ignore" (click)="cancel()">Cancel</button>

      <button type="submit" class="btn btn-success" (click)="save()"
              [disabled]="ongoingRequest || !updateDeploymentDomainForm.dirty || updateDeploymentDomainForm.invalid">
        @if (ongoingRequest) {
          <i class="fa-solid fa-spinner rotating"></i>
        } @else {
          Save
        }
      </button>
    </footer>
  </form>
</oaibox-stats-card>
